export const colorNames = () => {
    return {
      themeColor: "rgb(29, 161, 242)",
      boxShadowColors: {
        shadowColor1: "rgba(0, 0, 0, 0.14)",
        shadowColor2: "rgba(50, 50, 50, 0.09)",
        shadowColor3: "rgba(0, 0, 0, 0.4)"
      },
      customColors: {
        blackColor: "rgb(0, 0, 0)",
        blackColor1: "rgb(68, 68, 68)",
        blackColor2: "rgb(126, 126, 126)",
        blackColor3: "rgb(194, 194, 194)",
        whiteColor: "rgb(255, 255, 255)",
        whiteColor1: "rgba(255, 255, 255, 0.8)",
        whiteColor2: "rgba(203, 203, 203, 0.6)",
        whiteColor3: "rgba(250, 250, 250, 0.8)",
        lightBackground: "rgb(244, 244, 244)",
        lightBackground1: "rgba(180, 180, 174, 0.2)",
        lightBackground2: "rgb(224, 224, 224)",
        lightBackground3: "rgba(240, 237, 237, 0.59)",
        borderColor: "rgb(225, 224, 234)",
        borderColor1: "rgb(201, 201, 201)",
        redColor: "rgb(231, 57, 57)",
        redColorLight: "rgba(255, 0, 0, 0.15)",
        redColorLight1: "rgba(255, 0, 0, 0.062)",
        orangeColor: "rgb(252, 103, 54)",
        greenColor: "rgb(63, 228, 79)",
        greenColor1: "rgb(0, 110, 32)",
        greenColorLight: "rgba(63, 228, 79, 0.15)",
        yellowColor: "rgb(255, 199, 108)",
        yellowColor1: "rgb(234, 166, 36)",
        yellowColorLight: "rgba(255, 199, 108, 0.2)",
        blueColor1: "rgb(2, 192, 255)",
        blueColor2: "rgb(0, 114, 195)",
        blueColor3: "rgb(0, 101, 141)",
        blueColor4: "rgb(28, 65, 255)",
        blueColor5: "rgb(71, 85, 105)",
        blueColorLight: "rgba(2, 192, 255, 0.08)",
        blueColorLight1: "rgba(2, 192, 255, 0.03)",
        violet: "rgb(235, 38, 218)",
        violetLight: "rgba(235, 38, 219, 0.199)",
      }
    };
  }
  